/**
 * Component Registry for Sheridan Ridge Townhomes
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { GallerySeparator } from './components/GallerySeparator';
import { SisterProperties } from './components/SisterProperties';
import { TabbedCallouts } from './components/TabbedCallouts';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  GallerySeparator,
  SisterProperties,
  TabbedCallouts,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
